// extracted by mini-css-extract-plugin
export default {"Alumni":"Alumni_Alumni__wuLdN"};